var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 20.4644V3.53594C18.0066 3.53594 18.4062 3.66977 18.6989 3.93744C18.9914 4.20494 19.1376 4.61502 19.1376 5.16769V18.8269C19.1376 19.3786 18.9908 19.7894 18.6971 20.0594C18.4036 20.3294 18.0046 20.4644 17.5001 20.4644ZM3.50012 22.1019C3.03179 22.1019 2.63079 21.9351 2.29712 21.6014C1.96362 21.2679 1.79688 20.8669 1.79688 20.3984V3.60194C1.79688 3.13344 1.96362 2.73244 2.29712 2.39894C2.63079 2.06527 3.03179 1.89844 3.50012 1.89844H13.2969C13.7652 1.89844 14.1662 2.06527 14.4999 2.39894C14.8334 2.73244 15.0001 3.13344 15.0001 3.60194V20.3984C15.0001 20.8669 14.8334 21.2679 14.4999 21.6014C14.1662 21.9351 13.7652 22.1019 13.2969 22.1019H3.50012ZM21.6376 18.7959V5.21769C21.991 5.21769 22.2579 5.2961 22.4384 5.45294C22.619 5.60994 22.7094 5.88877 22.7094 6.28944V17.7302C22.7094 18.1317 22.619 18.4097 22.4384 18.5642C22.2579 18.7187 21.991 18.7959 21.6376 18.7959ZM3.50012 20.4164H13.2969V3.60194H3.50012V20.4164Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.10b8192423652ce0de3196aea230f5d3.svg";
export { ForwardRef as ReactComponent };